import type { Place } from "../data/schema";

export interface PlaceViewRanking {
  rank: number;
  placeId: string;
  name: string;
  category: Place["category"];
  region: Place["region"];
  district: string;
  viewCount: number;
  uniqueVisitors: number;
}

interface AnalyticsResponse {
  rankings: PlaceViewRanking[];
}

const visitorStorageKey = "askpapa-anonymous-visitor-id";

export async function trackPlaceView(placeId: string) {
  const body = JSON.stringify({
    placeId,
    visitorId: getVisitorId(),
    source: "place-detail",
  });

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon("/api/analytics", blob)) return;
  }

  await fetch("/api/analytics", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body,
    keepalive: true,
  });
}

export async function fetchPlaceViewRankings(period: "daily" | "weekly") {
  const response = await fetch(`/api/analytics?period=${period}&limit=10`, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Analytics API unavailable: ${response.status}`);
  }

  const payload = (await response.json()) as AnalyticsResponse;
  return Array.isArray(payload.rankings) ? payload.rankings : [];
}

function getVisitorId() {
  const current = window.localStorage.getItem(visitorStorageKey);
  if (current) return current;

  const next =
    window.crypto?.randomUUID?.() ||
    `visitor-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

  window.localStorage.setItem(visitorStorageKey, next);
  return next;
}
